module.exports = __webpack_public_path__ + "static/media/reduxjs.577c4fc5.svg";